/** Settings for the profile feature. */

// Profile picture (the server accepts png, jpg and webp up to 2 MB)
export const AVATAR_MAX_BYTES = 2 * 1024 * 1024; // 2 MB
export const AVATAR_ACCEPTED_TYPES = Object.freeze(['image/jpeg', 'image/png', 'image/webp']);

// Change password
export const PASSWORD_MIN_LENGTH = 8;

// Shown for a detail the profile does not have.
export const EMPTY_VALUE_TEXT = 'Not provided';
